import React, { Component } from 'react'
import PropTypes from 'prop-types'

class ConnectButtonForm extends Component {

	renderMessage() {
		const {connected} = this.props
		return connected ? [
			"계정 다시 연결하기",
			<span key="status" className="txt_em">(연결중)</span>
		] : "계정 연결하기"
	}


	render() {
		const { onClick } = this.props
		return (
			<button type="button" className="btn_cancel btn_plugin" onClick={onClick}>
				{ this.renderMessage() }
			</button>
		)
	}
}

ConnectButtonForm.propTypes = {
	connected: PropTypes.bool,
	onClick: PropTypes.func
}

export default ConnectButtonForm
